<template>
  <dashboard-section
      :bordered="$device.isMobileOrTablet"
      v-if="showSection">
    <div :id="'shopping_'+match.occupation_id" class="d-flex jc-between fd-column-reverse:mo w-100">
      <div>
        <h3 v-if="isHiredStatusAlias">
          Get supplies for this job
        </h3>
        <h3 v-else >
          Get ready for your next job
        </h3>
        <transition name="FADE" mode="out-in">
          <div>
            <button
                class="btn-secondary w-100:mo"
                @click.prevent="onShopClick">
              <span class="d-flex ai-center">{{ content.buttonLabel }}</span>
            </button>
          </div>
        </transition>
      </div>
      <div>
        <img
            v-if="content.image.url"
            :src="content.image.url"
            class="IMG"
        />
      </div>
    </div>
  </dashboard-section>
</template>

<script>
import { mapGetters } from 'vuex';

import jobParams from '@/mixins/job-params';
import job from '@/mixins/job';
import DashboardSection from '@/views/Dashboard/components/DashboardSection';


export default {
  name: 'pro-shopping',
  components: {
    DashboardSection,

  },
  mixins: [
    jobParams,
    job,
  ],
  computed: {
    ...mapGetters('ui', ['proShoppingIds']),
    ...mapGetters('user', ['userId']),
    content () {
      return this.proShoppingIds[this.match.occupation_id] || {};
    },
    showSection () {
      return !!this.content.occupationName;
    },

  },
  methods: {
    onShopClick () {
      window.open(this.content.link, '_blank');
      this.$events.$emit(this.$events.PRO_SHOPPING_CLICK, {
        occupation: this.content.occupationName,
        proId: this.userId,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  .WRAP-TEXT{
    word-break: break-word;
    white-space: normal;
  }
  .IMG {
    margin-top: 16px;
    width: 340px;
    height: 104px;
    @include mobile-only() {
        width: 100% ;
        height: 120px;
      }
  }
</style>
